import { render, staticRenderFns } from "./SalesOrderEdit.vue?vue&type=template&id=15ae6fd7&"
import script from "./SalesOrderEdit.vue?vue&type=script&lang=js&"
export * from "./SalesOrderEdit.vue?vue&type=script&lang=js&"
import style0 from "./SalesOrderEdit.vue?vue&type=style&index=0&id=15ae6fd7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports